/*eslint-disable*/
export default {
    'Introduction': 'Eurasia',
    'Moscow': 'Eurasia',
    'Oslo': 'Eurasia',
    'Berlin': 'Eurasia',
    'Paris': 'Eurasia',
    'Madrid': 'Eurasia',
    'Rome': 'Eurasia',
    'Istanbul': 'Eurasia',
    'Astana': 'Eurasia',
    'New-Delhi': 'Eurasia',
    'Bangkok': 'Eurasia',
    'Beijing': 'Eurasia',
    'Tokyo': 'Eurasia',
    'Cairo': 'Africa',
    'Algeria': 'Africa',
    'Marrakesh': 'Africa',
    'SaharaDesert': 'Africa',
    'Bamako': 'Africa',
    'Kinshasa': 'Africa',
    'CongoRiver': 'Africa',
    'CapeTown': 'Africa',
    'Tanzania': 'Africa',
    'MountKilimanjaro': 'Africa',
    'AddisAbaba': 'Africa',
    'MadagascarIsland': 'Africa',
    'ChurchOfTheHolyTrinity': 'Antarctica',
    'MountElsworth': 'Antarctica',
    'Iceberg': 'Antarctica',
    'IceMarathon': 'Antarctica',
    'AntarcticStationAmundsenScott': 'Antarctica',
    'Icebreaker': 'Antarctica',
    'AnimalsOfAntarctica': 'Antarctica',
    'ResearchStationProgress': 'Antarctica',
    'Wellington': 'Australia',
    'Hobbiton': 'Australia',
    'GreatBarrierReef': 'Australia',
    'PapuaNewGuinea': 'Australia',
    'CockatooNationalPark': 'Australia',
    'PinnacleDesert': 'Australia',
    'LakeHiller': 'Australia',
    'CliffUluru': 'Australia',
    'KangarooIsland': 'Australia',
    'RainForest': 'Australia',
    'BlueMountains': 'Australia',
    'Sydney': 'Australia',
    'EasterIsland': 'SouthAmerica',
    'AtacamaDesert': 'SouthAmerica',
    'Buenos-Aires': 'SouthAmerica',
    'Punto-Tombo': 'SouthAmerica',
    'ColoradoLagoon': 'SouthAmerica',
    'Machu-Picchu': 'SouthAmerica',
    'Quito': 'SouthAmerica',
    'GalapagosIslands': 'SouthAmerica',
    'Guatape': 'SouthAmerica',
    'AngelFalls': 'SouthAmerica',
    'AmazonRiver': 'SouthAmerica',
    'RioDeJaneiro': 'SouthAmerica',
    'JurassicPark': 'NorthAmerica',
    'Kingston': 'NorthAmerica',
    'SanJose': 'NorthAmerica',
    'Palenque': 'NorthAmerica',
    'MexicoCity': 'NorthAmerica',
    'Disneyland': 'NorthAmerica',
    'NewYork': 'NorthAmerica',
    'Ottawa': 'NorthAmerica',
    'Calgary': 'NorthAmerica',
    'StanleyPark': 'NorthAmerica',
    'Alaska': 'NorthAmerica',
    'Greenland': 'NorthAmerica',
    'ISS': 'Space',
    'Moon': 'Space',
    'Sun': 'Space',
    'Mercury': 'Space',
    'Jupiter': 'Space',
    'Mars': 'Space',
    'Neptune': 'Space',
    'Asteroids': 'Space',
    'Uranus': 'Space',
    'Saturn': 'Space',
    'BlackHole': 'Space',
    'Venus': 'Space',
    'FINAL': 'Space'
}